import { render } from "./NewsVertical.vue?vue&type=template&id=d16b8c52&scoped=true"
import script from "./NewsVertical.vue?vue&type=script&lang=js"
export * from "./NewsVertical.vue?vue&type=script&lang=js"

import "./NewsVertical.vue?vue&type=style&index=0&id=d16b8c52&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d16b8c52"]])

export default __exports__